<template><div><h1>VUX V2.3.4 released</h1>
<h2><a href="/en/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[feature] Support event: on-click-mask #1496</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] do not trigger on-change on first-value-setting</li>
</ul>
<h2><a href="/en/components/inline-loading.html">InlineLoading</a></h2>
<ul><li>[feature] new component</li>
</ul>
<h2><a href="/en/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] Fix click to fail when only two swiper-item and loop #1484 @unclay</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.4 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.4-105.vue?6d373e88